import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';

function ScenarioItem({ scenario }) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  const handleStartTest = () => {
    if (!currentUser) {
      navigate('/login');
      return;
    }
    
    navigate(`/test/${scenario.id}`);
  };
  
  return (
    <div className={`scenario-card ${!scenario.is_free ? 'scenario-card-premium' : ''}`}>
      {scenario.image && (
        <div className="scenario-image">
          <img src={scenario.image} alt={scenario.title} />
        </div>
      )}
      <h3>{scenario.title}</h3>
      <p className="scenario-description">{scenario.description.substring(0, 150)}...</p>
      
      <div className="scenario-card-footer">
        <span className={`scenario-badge ${scenario.is_free ? 'badge-free' : 'badge-premium'}`}>
          {scenario.is_free ? 'Free' : 'Premium'}
        </span>
        
        {(!currentUser && !scenario.is_free) ? (
          <button 
            className="secondary-button" 
            onClick={() => navigate('/login')}
          >
            Login to Access
          </button>
        ) : (
          <button 
            className="primary-button" 
            onClick={handleStartTest}
          >
            Start Test
          </button>
        )}
      </div>
    </div>
  );
}

export default ScenarioItem; 